import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/QRCode/codeParking";

export default class QrCodeParkingService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
